export interface SolarFinanceRequest {
  fullName: string;
  phoneNumber: string;
  email: string;
  accessAcount: string;
  closestBranch: string;
  workType: number | null;
  monthlyIncome: number;
  currency: number | null;
}

export interface SolarFinanceResponse {
  succeeded: boolean;
  message: string;
  errors: null;
  data: any;
  meta: any;
  code: number;
  pageMeta: any;
}

export enum Currencies {
  "Nigerian Naira" = 1,
  "United States Dollar" = 2,
  "EURO" = 3,
  "British Pound Sterling" = 4,
  "Japanese Yen" = 5,
  "Canadian Yen" = 6,
}

export const CurrencyArray = [
  "Nigerian Naira",
  "United States Dollar",
  "EURO",
  "British Pound Sterling",
  "Japanese Yen",
  "Canadian Dollar",
];

export enum WorkTypes {
    "Salary Earner" = 1,
    "Business Owner" = 2,
};

export const WorkTypeArray = ['Salary Earner', 'Business Owner']

export enum BankBranches {
  "CEMETARY MARKET BRANCH, ABA",
  "ABA, EZIUKWU ROAD",
  "UMUAHIA BRANCH",
  "15 AZIKWE ROAD",
  "FAULKS ROAD BRANCH ABA",
  "UMUDIKE BRANCH",
  "UMUAHIA, LIBRARY AVENUE",
  "ABA, ASA ROAD",
  "OGBOR HILL, IKOT EKPENE ROAD ABA",
  "ALAOJI, ABA - PORT HARCOURT ROAD",
  "UMUAHIA, IKOT - EKPENE ROAD",
  "OWERRI NTA,KM 3 UMUIKAA/OWERRI RD",
  "RET SHOP - OSISIOMA (001)",
  "RETAIL SHOP - ARIARIA (001)",
  "RET SHOP - UMUAHIA (039)",
  "RET SHOP - NGWA ROAD (078)",
  "YOLA BRANCH",
  "MUBI, MOHAMMED BELLO WAY",
  "UYO",
  "ORON BRANCH",
  "IKOT EKPENE BRANCH",
  "32 AKA ROAD BRANCH",
  "EKET BRANCH",
  "GIBBS STREET BRANCH",
  "UYO, ABAK ROAD",
  "UYO, BANK LAYOUT",
  "ABAK, IKOT - EKPENE ROAD",
  "ONITSHA - RELIEF MARKET BRANCH",
  "ONITSHA - 33 TRANS-NKISI BRANCH",
  "OBA BRANCH",
  "OWERRI - ALABA MARKET BRANCH",
  "ONITSHA BRANCH",
  "NNEWI BRANCH",
  "AWKA 2 BRANCH",
  "NEW MARKET ROAD BRANCH",
  "IHIALA BRANCH",
  "AWKA BRANCH 1",
  "UP IWEKA BRANCH",
  "BRIDGE HEAD BRANCH",
  "EKWULOBIA MAIN BRANCH",
  "STOCK EXCHANGE",
  "UNIZIK BRANCH",
  "UMUNZE BRANCH",
  "OGIDI BRANCH",
  "ONITSHA, NEW MARKET ROAD",
  "ONITSHA, PORT HARCOURT ROAD",
  "NNEWI, EDO-EZEMEWI STREET",
  "ONITSHA, SOKOTO ROAD",
  "ONITSHA, IWEKA ROAD",
  "ONITSHA, OGBARU ENAMEL WARE MARKET",
  "AWKA, AZIKIWE STREET",
  "NNEWI, OLD NKWO MARKET ROAD",
  "ONITSHA, NKPOR DEMUDE BRANCH",
  "OBOSI, CITY BISCUIT ROAD",
  "ONITSHA, NOTTIDGE ST MAIN MARKET",
  "OKIJA, OLD OKIJA IHIALA OGUTA RD",
  "AGULERI CLOSA OUTLET",
  "BAUCHI BRANCH",
  "YENOGOA BRANCH",
  "YENAGOA, CBD ABACHA ROAD",
  "RET SHOP-NIGER DELTA UNI. MINI(082)",
  "YENEGOA CLOSA OUTLET",
  "MAKURDI BRANCH",
  "GBOKO MAIN BRANCH",
  "GBOKO BRANCH",
  "ZAKI IBIAM BRANCH",
  "OTURKPO BRANCH",
  "MAKURDI, NEW BRIDGE ROAD",
  "RET SHOP - N/BANK MAKURDI (034)",
  "MAIDUGURI",
  "BIU BRANCH",
  "MAIDUGURI, BURGA ROAD",
  "RET SHOP - UNIV. OF MAIDUGURI (020)",
  "CALABAR BRANCH",
  "CALABAR 1",
  "OGOJA BRANCH",
  "IKOM, OKIMI OSABOR STREET",
  "CALABAR, MAYNE AVENUE",
  "CALABAR, NDIDEM USANG ISO ROAD",
  "WARRI, SAPELE ROAD",
  "ASABA BRANCH",
  "AGBOR BRANCH",
  "DECO ROAD BRANCH",
  "SAPELE BRANCH",
  "WARRI OKUMAGBA AVENUE",
  "AGBOR, OLD LAGOS - ASABA ROAD",
  "WARRI, UDU ROAD",
  "ASABA, 163 NNEBISI ROAD",
  "UGHELLI, MARKET ROAD",
  "RET SHOP - WARRI (005)",
  "OKPANAM ROAD BRANCH",
  "OLEH CLOSA OUTLET",
  "ABAKALIKI BRANCH 1",
  "ABAKILIKI 2 BRANCH",
  "ABAKALIKI, OGOJA ROAD",
  "RET SHOP - EBONYI STATE UNIV (035)",
  "BENIN BRANCH",
  "UNIBEN BRANCH",
  "SAPELE ROAD BRANCH",
  "USELU BRANCH",
  "MISSION ROAD BRANCH",
  "TEXTILE MILL ROAD BRANCH",
  "EKPOMA BRANCH",
  "23 AIRPORT ROAD BRANCH",
  "OKADA BRANCH",
  "AUCHI BRANCH",
  "IHAMA BRANCH",
  "UROMI BRANCH",
  "BENIN , AKPAKPAVA STREET",
  "BENIN, SAPELE ROAD",
  "BENIN, UGBOWO ROAD",
  "BENIN, MISSION ROAD",
  "BENIN, 123 BENIN-AGBOR ROAD",
  "EKENWA-BENIN BRANCH",
  "ADO-EKITI",
  "IJERO EKITI CASH CENTRE",
  "AJILOSUN, ADO EKITI BRANCH",
  "EKITI STATE UNIVERSITY BRANCH",
  "IKERE BRANCH",
  "OGUI ROAD BRANCH",
  "UNIVERSITY OF NIGERIA ENUGU BRANCH",
  "OKPARA AVENUE BRANCH",
  "ENUGU ROAD",
  "KENYATTA BRANCH",
  "ENUGU STATE UNIVERSITY BRANCH",
  "AGBANI ROAD BRANCH",
  "UNN NSUKKA BRANCH",
  "ABAKALIKI ROAD ENUGU",
  "ABAKPA NIKE BRANCH",
  "ENUGU,GARDEN AVENUE",
  "ENUGU, OKPARA AVENUE",
  "NSUKKA, ENUGU/OBA ROAD",
  "ENUGU, AGBANI ROAD",
  "ENUGU, 9TH MILE",
  "ENUGU, COAL CAMP MISSION AVENUE",
  "ENUGU, PRESIDENTIAL ROAD",
  "ENUGU, NIKE LAKE ROAD",
  "AMINU KANO ABUJA BRANCH",
  "NATIONAL ASSEMBLY BRANCH",
  "GARKI BRANCH",
  "ASOKORO BRANCH",
  "WUSE MARKET BRANCH",
  "JOS STREET BRANCH",
  "GARKI AREA 11 BRANCH",
  "WUSE 2 BRANCH",
  "KARU BRANCH",
  "UTAKO BRANCH",
  "LADOKE AKINTOLA BLVD BRANCH",
  "DEI DEI BRANCH",
  "FED MIN OF JUSTICE BRANCH",
  "ABUJA NNPC TOWERS BRANCH",
  "MAITAMA BRANCH",
  "GWAGWALADA BRANCH",
  "DURUMI BRANCH",
  "GWARIMPA BRANCH",
  "GARKI ABUJA, CENTRAL BUSINESS AREA",
  "DEI DEI ABUJA, BUILDING MATERIALS MARKET",
  "RET SHOP -FED. SECRETARIAT ABJ(061)",
  "WUSE II ABUJA, ADETOKUNBO ADEMOLA CRESCENT",
  "GARKI ABUJA, MOHAMMED BUHARI WAY",
  "NYANYA ABUJA, OPP. NYANYA SHOPPING COMPLEX",
  "GARKI ABUJA, AHMADU BELLO WAY",
  "KUBWA ABUJA, NASCO ROAD",
  "ZONE 4 ABUJA, HERBERT MACAULEY WAY",
  "GWAGWALADA ABUJA, PARK LANE",
  "WUSE 2 ABUJA, AMINU KANO CRESCENT",
  "GWARINPA",
  "ZONE 5 ABUJA, MICHAEL OKPARA STREET",
  "LIFE CAMP ABUJA, JABI-KARMO ROAD",
  "RET SHOP- SAVANNAH SUITES, ABJ(013)",
  "RET SHOP -AREA 1 COMPLEX ABUJA(077)",
  "RET SHOP - GUDU MARKET, ABUJA (077)",
  "GOMBE BRANCH",
  "ASHAKA CASH CENTRE",
  "DUKKU BRANCH",
  "YAMALTU DEBA BRANCH",
  "KUMO BRANCH",
  "GOMBE, BIU RD.",
  "OWERRI BRANCH",
  "BANK ROAD OWERRI BRANCH",
  "ORLU BRANCH",
  "NEKEDE BRANCH",
  "MBAISE BRANCH",
  "OWERRI, WAAST AVENUE, IKENEGBU",
  "OWERRI, DOUGLAS ROAD",
  "ORLU, ORLU INTERNATIONAL MARKET",
  "OWERRI, ORLU ROAD",
  "OWERRI, WETHERAL ROAD BRANCH",
  "OKIGWE, WESLEY QUARTERS OKIGWE",
  "RD",
  "MBAISE, AHIARA JUNCTION MBAISE",
  "OKIGWE, 58 OWERRI ROAD",
  "RET SHOP - FUTO (017)",
  "RET SHOP - IMO STATE SECTARIAT(090)",
  "RET SHOP - NAZE MARKET (090)",
  "DUTSE, SANI ABACHA WAY",
  "KAZAURE BRANCH",
  "HADEJIA BRANCH",
  "KADUNA BRANCH",
  "ALI AKILU ROAD BRANCH",
  "ZARIA BRANCH",
  "KACHIA ROAD KADUNA",
  "A2 AHMADU BELLO WAY BRANCH",
  "KAFANCHAN BRANCH",
  "UNGWAN RIMI BRANCH",
  "NNPC REFINERY KADUNA BRANCH",
  "GUMI MAIN MARKET",
  "ANCHAU BRANCH",
  "KADUNA, 1 KACHIA ROAD",
  "KADUNA, 23 AHMADU BELLO WAY",
  "JAJI, COMMAND AND STAFF COLLEGE",
  "KADUNA, BENIN STREET/KANO ROAD",
  "KADUNA, ISA KAITA ROAD",
  "RET SHOP - ZARIA (127)",
  "GONIN-GORA CLOSA OUTLET",
  "KANO BRANCH",
  "BICHI BRANCH",
  "MUR MOHAMMED WAY, KANO",
  "BELLO ROAD BRANCH KANO",
  "KATIN KWARI BRANCH",
  "BAYERO UNIVERSITY BRANCH",
  "AMINU KANO TEACHING HOSPITAL",
  "FRANCE ROAD BRANCH",
  "SINGER MARKET BRANCH",
  "KANO, MURTALA MOHAMMED WAY",
  "KANO, BANK ROAD",
  "KANO, FRANCE ROAD, SABON GARI",
  "RET SHOP - BAYERO UNI. KANO (007)",
  "RET SHOP - DAWANUA, KANO (058)",
  "KATSINA BRANCH",
  "KATSINA 2 BRANCH",
  "FUNTUA BRANCH",
  "DAURA BRANCH",
  "MALUMFASHI BRANCH",
  "KAFUR BRANCH",
  "DANJA BRANCH",
  "KATSINA, NAGODO ROAD",
  "BIRNIN KEBBI BRANCH",
  "BIRNIN KEBBI, SANI ABACHA ROAD",
  "OBAJANA CASH CENTRE",
  "LOKOJA BRANCH",
  "OKENE BRANCH",
  "ANYIGBA BRANCH",
  "LOKOJA, MURTALA MUHAMMED WAY",
  "EGBE CLOSA OUTLET",
  "OKENE CLOSA OUTLET",
  "ILORIN BRANCH",
  "FOLAWIYO STREET BRANCH",
  "KWARA STATE POLYTECHNIC",
  "ILORIN, IBRAHIM TAIWO ROAD",
  "ILORIN, UMARU AUDI ROAD",
  "TRINITY TOWERS BRANCH",
  "BURMA ROAD APAPA BRANCH",
  "IDUMOTA BRANCH",
  "BROAD STREET BRANCH",
  "AGUDA BRANCH",
  "IKORODU BRANCH",
  "ALLEN AVENUE IKEJA BRANCH",
  "VICTORIA ISLAND BRANCH",
  "LAGOS ISLAND, KING GEORGE V",
  "IDEJO BRANCH",
  "COMMERCIAL ROAD, APAPA BRANCH",
  "CREEK ROAD APAPA BRANCH",
  "TRADE FAIR BRANCH",
  "TINCAN ISLAND BRANCH",
  "OLD OJO BRANCH",
  "IPAJA BRANCH",
  "PALM AVENUE BRANCH",
  "SIMBIAT ABIOLA IKEJA BRANCH",
  "IKOTA BRANCH",
  "ADETOKUNBO ADEMOLA BRANCH",
  "ASPAMDA BRANCH",
  "ALABA INTERNATIONAL MARKET",
  "MARYLAND BRANCH",
  "OGUNLANA DRIVE BRANCH",
  "FESTAC TOWN BRANCH",
  "LIGALI AYORINDE",
  "ILUPEJU BRANCH",
  "IBAFON BRANCH",
  "POINT ROAD BRANCH",
  "OGBA BRANCH",
  "IDI-ARABA BRANCH",
  "LEKKI CHEVRON BRANCH",
  "ADEOLA ODEKU BRANCH",
  "OJODU BERGER BRANCH",
  "MATORI BRANCH",
  "ALFRED REWANE ROAD",
  "71 ADENIRAN OGUNSANYA BRANCH",
  "MAZA MAZA BRANCH",
  "ADEOLA HOPEWELL BRANCH",
  "48 MARINA BRANCH",
  "ALAGBADO BRANCH",
  "IKORODU 2 BRANCH",
  "BROAD STREET 2 BRANCH",
  "TEJUOSHO BRANCH",
  "IFAKO-GBAGADA BRANCH",
  "67 ST FINBARRS RD-BARIGA",
  "OBA AKRAN BRANCH",
  "AWOLOWO ROAD 2 BRANCH",
  "MOLONEY BRANCH",
  "ISOLO 1 BRANCH",
  "ILUPEJU 2 BRANCH",
  "GBAGADA BRANCH",
  "LEKKI 1 BRANCH",
  "AJOSE ADEOGUN BRANCH",
  "JIBOWU BRANCH",
  "NAHCO BRANCH",
  "OPEBI BRANCH",
  "KETU BRANCH",
  "ORILE COKER",
  "ABULE-EGBA BRANCH",
  "SATELLITE TOWN BRANCH",
  "IKEJA, AWOLOWO WAY",
  "OJOTA BRANCH",
  "NNAMDI AZIKWE STREET IDUMOTA",
  "EGBEDA BRANCH",
  "ODOGUNYAN BRANCH",
  "IKOTUN BRANCH",
  "SOMOLU BRANCH",
  "AYOBO BRANCH",
  "EJIGBO BRANCH",
  "LASU BRANCH",
  "BODE THOMAS BRANCH",
  "IJESHATEDO BRANCH",
  "MUSHIN BRANCH",
  "UNIVERSITY OF LAGOS BRANCH",
  "IRE AKARI BRANCH",
  "SABO YABA BRANCH",
  "MURI OKUNOLA BRANCH",
  "SAKA TINUBU BRANCH",
  "LAWANSON BRANCH",
  "IJU BRANCH",
  "OSHODI BRANCH",
  "IDIMU BRANCH",
  "ADENIJI ADELE BRANCH",
  "DOPEMU BRANCH",
  "FESTAC 2 BRANCH",
  "EPE BRANCH",
  "ADMIRALTY WAY BRANCH",
  "IBEJU LEKKI",
  "EBUTE METTA BRANCH",
  "LASU CAMPUS BRANCH",
  "ISOLO, ASA-AFARIOGUN STREET, AJAO",
  "ESTATE",
  "LAGOS ISLAND, MARINA",
  "APAPA, WHARF ROAD",
  "IKEJA, LADIPO OLUWOLE STREET",
  "LAGOS ISLAND, BALOGUN STREET",
  "ALABA INTERNATIONAL, OLD GARAGE",
  "VICTORIA ISLAND, ADEOLA ODEKU",
  "TRADE FAIR COMPLEX, ASPAMDA, HALL",
  "MATORI, LADIPO STREET",
  "COKER, LAGOS/BADAGRY EXPRESSWAY",
  "BBA LAGOS, ATIKU ABUBAKAR PLAZA",
  "EBUTE METTA, MARKET STREET",
  "OYINGBO",
  "IKOYI, AWOLOWO ROAD",
  "LAGOS ISLAND, BROAD STREET",
  "IKEJA, 60 OPEBI ROAD",
  "ALABA INTERNATIONAL, DOBBILL PLAZA",
  "AVENUE",
  "BBA LAGOS, BANK PLAZA",
  "TRADE FAIR COMPLEX, ASPAMDA",
  "OFFICE BLOCK 2",
  "OGBA, IJAIYE ROAD",
  "APAPA, OSHODI EXPRESSWAY",
  "LAGOS ISLAND, OKE ARIN",
  "YABA, HERBERT MACAULAY ROAD",
  "BRANCH",
  "IKORODU, 83 LAGOS ROAD",
  "LEKKI, LEKKI-EPE EXPRESSWAY",
  "LAGOS ISLAND, ENU OWA STREET",
  "FESTAC TOWN, SECOND AVENUE",
  "IYANA IPAJA, LAGOS ABEOKUTA",
  "EXPRESS WAY",
  "SEME BORDER, BADAGRY EXPRESS WAY",
  "LAWANSON/ITIRE RD BRANCH",
  "AMUWO ODOFIN BRANCH",
  "APAPA, LIVERPOOL ROAD",
  "ALAUSA BRANCH",
  "MAZA MAZA, OLD OJO ROAD",
  "ISOLO, MUSHIN ROAD",
  "APAPA, BURMA ROAD",
  "AJAH, LEKKI - EPE EXPRESSWAY",
  "OREGUN, ZIATECH ROAD OREGUN",
  "IDIMU, IDIMU ROAD IKOTUN",
  "ILASA, APAPA OSHODI EXPRESSWAY",
  "OKOTA, 56 AGO PALACE WAY",
  "APONGBON, ISSA WILLIAMS/OFFIN RD",
  "GBAGADA, GBAGADA EXPRESSWAY",
  "IKEJA GRA, JOEL OGUNNAIKE STREET",
  "MAGODO, CMD ROAD IKOSI",
  "AKOWONJO, SHASHA ROAD",
  "ALABA, DENSINE PLAZA OLOJO DRIVE",
  "OJUELEGBA, SHIFAWU STREET",
  "MARYLAND,MOBOLAJI BANK ANTHONY WAY",
  "BADAGRY, JOSEPH DOSU ROAD",
  "OBALENDE, KEFFI STREET",
  "SURULERE, ENITAN STREET AGUDA",
  "OSHODI, OSHODI-APAPA EXPRESSWAY",
  "AJAH, ADDO ROAD",
  "MAFOLUKU, INTL AIRPORT ROAD",
  "LEKKI PHASE I, ADMIRALTY WAY",
  "RET SHOP - JANKARA , LAGOS ISD(002)",
  "RET SHOP - OKOTA, ISOLO LAGOS (004)",
  "RET SHOP - RORO PORT (010)",
  "RET SHOP - ALUMINUM VILLAGE (011)",
  "RET SHOP - TEJUOSHO MKT, LAG (050)",
  "RET SHOP - IDDO, EBUTE METTA",
  "RET SHOP - OGUNLANA DRIVE (051)",
  "RET SHOP - ISHERI, BERGER",
  "RET SHOP - IFAKO AGEGE (080)",
  "RET SHOP-KIRIKIRI, APAPA LAGOS(083)",
  "RET SHOP - IFAKO GBAGADA (087)",
  "RET SHOP - BARIGA AKOKA (087)",
  "RET SHOP - KETU (088)",
  "RET SHOP - IKOTA, VGC LAGOS (095)",
  "RET SHOP - DALEKO (099)",
  "RET SHOP - MAFOLUKU (027)",
  "RET SHOP - OJUWOYE MARKET (099)",
  "RET SHOP - IYANA IPAJA (110)",
  "BOGIJE CLOSA OUTLET",
  "SANGOTEDO CLOSA OUTLET",
  "AGBOWA CLOSA OUTLET",
  "ETIEBET’S HOUSE BRANCH",
  "NUMBER ONE BRANCH",
  "ORIWU BRANCH",
  "LAFIA BRANCH",
  "MARARABA BRANCH",
  "KEFFI BRANCH",
  "LAFIA, DOMA ROAD",
  "AKWANGA, KEFFI ROAD",
  "KEFFI, ABUBAKAR BURGA STREET",
  "NEW KARU BRANCH",
  "RET SHOP-NASS. STATE UNI.KEFFI(073)",
  "MINNA BRANCH",
  "SULEJA BRANCH",
  "BIDA BRANCH",
  "MINNA 2 BRANCH",
  "MINNA, PAIKO ROAD",
  "SULEJA, IBB MARKET",
  "ABEOKUTA BRANCH",
  "AGBARA BRANCH",
  "OKE ILEWO BRANCH",
  "RCCG CAMP BRANCH",
  "OTTA BRANCH",
  "ILARO BRANCH",
  "IJEBU-ODE BRANCH",
  "COVENANT BRANCH",
  "SAGAMU BRANCH",
  "OOU BRANCH",
  "AKUTE BRANCH",
  "IBAFO BRANCH",
  "ABEOKUTA, UACN COMPLEX IBARA",
  "OTTA, OTTA INDUSTRIAL LAYOUT",
  "OWODE YEWA MARKET BRANCH",
  "IDI IROKO BORDER BRANCH",
  "SAGAMU, AKARIGBO STREET",
  "IJEBU ODE, 35 IBADAN ROAD",
  "OTTA, IDIROKO ROAD",
  "ABEOKUTA, ADATAN ROAD",
  "RET SHOP - BABCOCK UNIVERSITY (137)",
  "AKURE BRANCH",
  "ADO OWO ROAD BRANCH",
  "ONDO BRANCH",
  "ADEKUNLE AJASIN UNIVERSITY CAMPUS BRANCH",
  "ADEYEMI COLLEGE OF EDUCATION",
  "AKURE, OYEMEKUN STREET",
  "ONDO, YABA ROAD",
  "ORE BRANCH",
  "OWO BRANCH",
  "OSHOGBO BRANCH",
  "ILESHA BRANCH",
  "ILE IFE BRANCH",
  "OAU ILE IFE BRANCH",
  "REDEEMER UNIVERSITY EDE BRANCH",
  "OSHOGBO, GBONGAN-IBADAN ROAD",
  "IREE BRANCH",
  "ILESHA, ITA BALOGUN STREET",
  "ILE - IFE, LAGERE ROAD",
  "IPETU IJESHA BRANCH",
  "UNIVERSITY OF IBADAN,CAMPUS BRANCH",
  "DUGBE MARKET IBADAN BRANCH",
  "IWO ROAD IBADAN BRANCH",
  "BODIJA BRANCH 1",
  "NEW COURT ROAD BRANCH",
  "OYO BRANCH",
  "BODIJA BRANCH 2",
  "OJOO BRANCH",
  "OGBOMOSO BRANCH",
  "IWO ROAD 2 BRANCH",
  "EKOTEDO BRANCH IBADAN",
  "RING ROAD, IBADAN BRANCH",
  "UCH IBADAN BRANCH",
  "CHALLENGE BRANCH",
  "LAUTECH BRANCH",
  "IBADAN, LEBANON STREET",
  "APATA-IBADAN BRANCH",
  "SAKI BRANCH",
  "APOMU BRANCH",
  "ERUWA BRANCH",
  "AKANRAN - IBADAN BRANCH",
  "IBADAN, OKE - ADO",
  "IBADAN, AGODI UCH SECOND GATE",
  "IBADAN, AGBENI MARKET",
  "OGBOMOSHO, ILORIN ROAD",
  "SANGO-IBADAN BRANCH",
  "MONOTAN-IBADAN BRANCH",
  "GBAGI MARKET BRANCH",
  "JOS BRANCH",
  "JOS 1 BRANCH",
  "BUKURU BRANCH",
  "JOS, COMMERCIAL AREA",
  "JOS, AHMADU BELLO WAY",
  "JOS, CLUB ROAD",
  "BUKURU, OLD JOS ROAD",
  "RET SHOP - KATAKO (015)",
  "RET SHOP - UNIVERSITY OF JOS (055)",
  "REGIONAL OFFICE PORT HARCOURT",
  "TRANS AMADI BRANCH",
  "OLU OBASANJO BRANCH",
  "BONNY CASH CENTRE",
  "AGIP ROAD BRANCH",
  "BANK ROAD PH BRANCH",
  "RUMUOKORO BRANCH",
  "OBIGBO BRANCH",
  "WOJI BRANCH",
  "ELEME BRANCH",
  "PLOT105 OLU OBASANJO PH BRANCH",
  "EASTERN BULKCEMENT BRANCH",
  "RUMUKURISHI BRANCH",
  "UNIPORT BRANCH",
  "AZIKIWE ROAD PHC BRANCH",
  "IKOKWU BRANCH",
  "RSUST BRANCH",
  "PH, TRANS AMADI",
  "PH, 222 IKWERRE ROAD",
  "PH, FOT ONNE",
  "PH, 50 IKWERRE ROAD",
  "PORT HARCOURT 82/88 ABA RD",
  "OBIGBO PH, LOCATION ROAD",
  "PH, SILVER VALLEY TRANS-AMADI RD",
  "PH, RUMUOKORO EAST - WEST ROAD",
  "PH, OLU OBASANJO WAY",
  "RET SHOP - 316 ABA ROAD (003)",
  "RET SHOP - ODUA ROAD, PHC (003)",
  "RET SHOP - OLD ABA ROAD, PH (086)",
  "BORI BRANCH",
  "ABULOMA CLOSA OUTLET",
  "ISIOKPO BRANCH",
  "SOKOTO BRANCH",
  "SOKOTO 2 BRANCH",
  "USMAN DANFODIO UNIVERSITY BRANCH",
  "SHAGARI BRANCH",
  "SOKOTO, MAIDUGURI ROAD",
  "GADA MARKET BRANCH",
  "JALINGO, HAMMAN RUN WAY",
  "DAMATURU BRANCH",
  "POTISKUM BRANCH",
  "GUSAU BRANCH",
  "TALATA MAFARA",
  "GUSAU, CANTEEN ROAD",
  "KAURA NAMODA BRANCH"


}

export const BankBranchesArray = [
  "CEMETARY MARKET BRANCH, ABA",
  "ABA, EZIUKWU ROAD",
  "UMUAHIA BRANCH",
  "15 AZIKWE ROAD",
  "FAULKS ROAD BRANCH ABA",
  "UMUDIKE BRANCH",
  "UMUAHIA, LIBRARY AVENUE",
  "ABA, ASA ROAD",
  "OGBOR HILL, IKOT EKPENE ROAD ABA",
  "ALAOJI, ABA - PORT HARCOURT ROAD",
  "UMUAHIA, IKOT - EKPENE ROAD",
  "OWERRI NTA,KM 3 UMUIKAA/OWERRI RD",
  "RET SHOP - OSISIOMA (001)",
  "RETAIL SHOP - ARIARIA (001)",
  "RET SHOP - UMUAHIA (039)",
  "RET SHOP - NGWA ROAD (078)",
  "YOLA BRANCH",
  "MUBI, MOHAMMED BELLO WAY",
  "UYO",
  "ORON BRANCH",
  "IKOT EKPENE BRANCH",
  "32 AKA ROAD BRANCH",
  "EKET BRANCH",
  "GIBBS STREET BRANCH",
  "UYO, ABAK ROAD",
  "UYO, BANK LAYOUT",
  "ABAK, IKOT - EKPENE ROAD",
  "ONITSHA - RELIEF MARKET BRANCH",
  "ONITSHA - 33 TRANS-NKISI BRANCH",
  "OBA BRANCH",
  "OWERRI - ALABA MARKET BRANCH",
  "ONITSHA BRANCH",
  "NNEWI BRANCH",
  "AWKA 2 BRANCH",
  "NEW MARKET ROAD BRANCH",
  "IHIALA BRANCH",
  "AWKA BRANCH 1",
  "UP IWEKA BRANCH",
  "BRIDGE HEAD BRANCH",
  "EKWULOBIA MAIN BRANCH",
  "STOCK EXCHANGE",
  "UNIZIK BRANCH",
  "UMUNZE BRANCH",
  "OGIDI BRANCH",
  "ONITSHA, NEW MARKET ROAD",
  "ONITSHA, PORT HARCOURT ROAD",
  "NNEWI, EDO-EZEMEWI STREET",
  "ONITSHA, SOKOTO ROAD",
  "ONITSHA, IWEKA ROAD",
  "ONITSHA, OGBARU ENAMEL WARE MARKET",
  "AWKA, AZIKIWE STREET",
  "NNEWI, OLD NKWO MARKET ROAD",
  "ONITSHA, NKPOR DEMUDE BRANCH",
  "OBOSI, CITY BISCUIT ROAD",
  "ONITSHA, NOTTIDGE ST MAIN MARKET",
  "OKIJA, OLD OKIJA IHIALA OGUTA RD",
  "AGULERI CLOSA OUTLET",
  "BAUCHI BRANCH",
  "YENOGOA BRANCH",
  "YENAGOA, CBD ABACHA ROAD",
  "RET SHOP-NIGER DELTA UNI. MINI(082)",
  "YENEGOA CLOSA OUTLET",
  "MAKURDI BRANCH",
  "GBOKO MAIN BRANCH",
  "GBOKO BRANCH",
  "ZAKI IBIAM BRANCH",
  "OTURKPO BRANCH",
  "MAKURDI, NEW BRIDGE ROAD",
  "RET SHOP - N/BANK MAKURDI (034)",
  "MAIDUGURI",
  "BIU BRANCH",
  "MAIDUGURI, BURGA ROAD",
  "RET SHOP - UNIV. OF MAIDUGURI (020)",
  "CALABAR BRANCH",
  "CALABAR 1",
  "OGOJA BRANCH",
  "IKOM, OKIMI OSABOR STREET",
  "CALABAR, MAYNE AVENUE",
  "CALABAR, NDIDEM USANG ISO ROAD",
  "WARRI, SAPELE ROAD",
  "ASABA BRANCH",
  "AGBOR BRANCH",
  "DECO ROAD BRANCH",
  "SAPELE BRANCH",
  "WARRI OKUMAGBA AVENUE",
  "AGBOR, OLD LAGOS - ASABA ROAD",
  "WARRI, UDU ROAD",
  "ASABA, 163 NNEBISI ROAD",
  "UGHELLI, MARKET ROAD",
  "RET SHOP - WARRI (005)",
  "OKPANAM ROAD BRANCH",
  "OLEH CLOSA OUTLET",
  "ABAKALIKI BRANCH 1",
  "ABAKILIKI 2 BRANCH",
  "ABAKALIKI, OGOJA ROAD",
  "RET SHOP - EBONYI STATE UNIV (035)",
  "BENIN BRANCH",
  "UNIBEN BRANCH",
  "SAPELE ROAD BRANCH",
  "USELU BRANCH",
  "MISSION ROAD BRANCH",
  "TEXTILE MILL ROAD BRANCH",
  "EKPOMA BRANCH",
  "23 AIRPORT ROAD BRANCH",
  "OKADA BRANCH",
  "AUCHI BRANCH",
  "IHAMA BRANCH",
  "UROMI BRANCH",
  "BENIN , AKPAKPAVA STREET",
  "BENIN, SAPELE ROAD",
  "BENIN, UGBOWO ROAD",
  "BENIN, MISSION ROAD",
  "BENIN, 123 BENIN-AGBOR ROAD",
  "EKENWA-BENIN BRANCH",
  "ADO-EKITI",
  "IJERO EKITI CASH CENTRE",
  "AJILOSUN, ADO EKITI BRANCH",
  "EKITI STATE UNIVERSITY BRANCH",
  "IKERE BRANCH",
  "OGUI ROAD BRANCH",
  "UNIVERSITY OF NIGERIA ENUGU BRANCH",
  "OKPARA AVENUE BRANCH",
  "ENUGU ROAD",
  "KENYATTA BRANCH",
  "ENUGU STATE UNIVERSITY BRANCH",
  "AGBANI ROAD BRANCH",
  "UNN NSUKKA BRANCH",
  "ABAKALIKI ROAD ENUGU",
  "ABAKPA NIKE BRANCH",
  "ENUGU,GARDEN AVENUE",
  "ENUGU, OKPARA AVENUE",
  "NSUKKA, ENUGU/OBA ROAD",
  "ENUGU, AGBANI ROAD",
  "ENUGU, 9TH MILE",
  "ENUGU, COAL CAMP MISSION AVENUE",
  "ENUGU, PRESIDENTIAL ROAD",
  "ENUGU, NIKE LAKE ROAD",
  "AMINU KANO ABUJA BRANCH",
  "NATIONAL ASSEMBLY BRANCH",
  "GARKI BRANCH",
  "ASOKORO BRANCH",
  "WUSE MARKET BRANCH",
  "JOS STREET BRANCH",
  "GARKI AREA 11 BRANCH",
  "WUSE 2 BRANCH",
  "KARU BRANCH",
  "UTAKO BRANCH",
  "LADOKE AKINTOLA BLVD BRANCH",
  "DEI DEI BRANCH",
  "FED MIN OF JUSTICE BRANCH",
  "ABUJA NNPC TOWERS BRANCH",
  "MAITAMA BRANCH",
  "GWAGWALADA BRANCH",
  "DURUMI BRANCH",
  "GWARIMPA BRANCH",
  "GARKI ABUJA, CENTRAL BUSINESS AREA",
  "DEI DEI ABUJA, BUILDING MATERIALS MARKET",
  "RET SHOP -FED. SECRETARIAT ABJ(061)",
  "WUSE II ABUJA, ADETOKUNBO ADEMOLA CRESCENT",
  "GARKI ABUJA, MOHAMMED BUHARI WAY",
  "NYANYA ABUJA, OPP. NYANYA SHOPPING COMPLEX",
  "GARKI ABUJA, AHMADU BELLO WAY",
  "KUBWA ABUJA, NASCO ROAD",
  "ZONE 4 ABUJA, HERBERT MACAULEY WAY",
  "GWAGWALADA ABUJA, PARK LANE",
  "WUSE 2 ABUJA, AMINU KANO CRESCENT",
  "GWARINPA",
  "ZONE 5 ABUJA, MICHAEL OKPARA STREET",
  "LIFE CAMP ABUJA, JABI-KARMO ROAD",
  "RET SHOP- SAVANNAH SUITES, ABJ(013)",
  "RET SHOP -AREA 1 COMPLEX ABUJA(077)",
  "RET SHOP - GUDU MARKET, ABUJA (077)",
  "GOMBE BRANCH",
  "ASHAKA CASH CENTRE",
  "DUKKU BRANCH",
  "YAMALTU DEBA BRANCH",
  "KUMO BRANCH",
  "GOMBE, BIU RD.",
  "OWERRI BRANCH",
  "BANK ROAD OWERRI BRANCH",
  "ORLU BRANCH",
  "NEKEDE BRANCH",
  "MBAISE BRANCH",
  "OWERRI, WAAST AVENUE, IKENEGBU",
  "OWERRI, DOUGLAS ROAD",
  "ORLU, ORLU INTERNATIONAL MARKET",
  "OWERRI, ORLU ROAD",
  "OWERRI, WETHERAL ROAD BRANCH",
  "OKIGWE, WESLEY QUARTERS OKIGWE",
  "RD",
  "MBAISE, AHIARA JUNCTION MBAISE",
  "OKIGWE, 58 OWERRI ROAD",
  "RET SHOP - FUTO (017)",
  "RET SHOP - IMO STATE SECTARIAT(090)",
  "RET SHOP - NAZE MARKET (090)",
  "DUTSE, SANI ABACHA WAY",
  "KAZAURE BRANCH",
  "HADEJIA BRANCH",
  "KADUNA BRANCH",
  "ALI AKILU ROAD BRANCH",
  "ZARIA BRANCH",
  "KACHIA ROAD KADUNA",
  "A2 AHMADU BELLO WAY BRANCH",
  "KAFANCHAN BRANCH",
  "UNGWAN RIMI BRANCH",
  "NNPC REFINERY KADUNA BRANCH",
  "GUMI MAIN MARKET",
  "ANCHAU BRANCH",
  "KADUNA, 1 KACHIA ROAD",
  "KADUNA, 23 AHMADU BELLO WAY",
  "JAJI, COMMAND AND STAFF COLLEGE",
  "KADUNA, BENIN STREET/KANO ROAD",
  "KADUNA, ISA KAITA ROAD",
  "RET SHOP - ZARIA (127)",
  "GONIN-GORA CLOSA OUTLET",
  "KANO BRANCH",
  "BICHI BRANCH",
  "MUR MOHAMMED WAY, KANO",
  "BELLO ROAD BRANCH KANO",
  "KATIN KWARI BRANCH",
  "BAYERO UNIVERSITY BRANCH",
  "AMINU KANO TEACHING HOSPITAL",
  "FRANCE ROAD BRANCH",
  "SINGER MARKET BRANCH",
  "KANO, MURTALA MOHAMMED WAY",
  "KANO, BANK ROAD",
  "KANO, FRANCE ROAD, SABON GARI",
  "RET SHOP - BAYERO UNI. KANO (007)",
  "RET SHOP - DAWANUA, KANO (058)",
  "KATSINA BRANCH",
  "KATSINA 2 BRANCH",
  "FUNTUA BRANCH",
  "DAURA BRANCH",
  "MALUMFASHI BRANCH",
  "KAFUR BRANCH",
  "DANJA BRANCH",
  "KATSINA, NAGODO ROAD",
  "BIRNIN KEBBI BRANCH",
  "BIRNIN KEBBI, SANI ABACHA ROAD",
  "OBAJANA CASH CENTRE",
  "LOKOJA BRANCH",
  "OKENE BRANCH",
  "ANYIGBA BRANCH",
  "LOKOJA, MURTALA MUHAMMED WAY",
  "EGBE CLOSA OUTLET",
  "OKENE CLOSA OUTLET",
  "ILORIN BRANCH",
  "FOLAWIYO STREET BRANCH",
  "KWARA STATE POLYTECHNIC",
  "ILORIN, IBRAHIM TAIWO ROAD",
  "ILORIN, UMARU AUDI ROAD",
  "TRINITY TOWERS BRANCH",
  "BURMA ROAD APAPA BRANCH",
  "IDUMOTA BRANCH",
  "BROAD STREET BRANCH",
  "AGUDA BRANCH",
  "IKORODU BRANCH",
  "ALLEN AVENUE IKEJA BRANCH",
  "VICTORIA ISLAND BRANCH",
  "LAGOS ISLAND, KING GEORGE V",
  "IDEJO BRANCH",
  "COMMERCIAL ROAD, APAPA BRANCH",
  "CREEK ROAD APAPA BRANCH",
  "TRADE FAIR BRANCH",
  "TINCAN ISLAND BRANCH",
  "OLD OJO BRANCH",
  "IPAJA BRANCH",
  "PALM AVENUE BRANCH",
  "SIMBIAT ABIOLA IKEJA BRANCH",
  "IKOTA BRANCH",
  "ADETOKUNBO ADEMOLA BRANCH",
  "ASPAMDA BRANCH",
  "ALABA INTERNATIONAL MARKET",
  "MARYLAND BRANCH",
  "OGUNLANA DRIVE BRANCH",
  "FESTAC TOWN BRANCH",
  "LIGALI AYORINDE",
  "ILUPEJU BRANCH",
  "IBAFON BRANCH",
  "POINT ROAD BRANCH",
  "OGBA BRANCH",
  "IDI-ARABA BRANCH",
  "LEKKI CHEVRON BRANCH",
  "ADEOLA ODEKU BRANCH",
  "OJODU BERGER BRANCH",
  "MATORI BRANCH",
  "ALFRED REWANE ROAD",
  "71 ADENIRAN OGUNSANYA BRANCH",
  "MAZA MAZA BRANCH",
  "ADEOLA HOPEWELL BRANCH",
  "48 MARINA BRANCH",
  "ALAGBADO BRANCH",
  "IKORODU 2 BRANCH",
  "BROAD STREET 2 BRANCH",
  "TEJUOSHO BRANCH",
  "IFAKO-GBAGADA BRANCH",
  "67 ST FINBARRS RD-BARIGA",
  "OBA AKRAN BRANCH",
  "AWOLOWO ROAD 2 BRANCH",
  "MOLONEY BRANCH",
  "ISOLO 1 BRANCH",
  "ILUPEJU 2 BRANCH",
  "GBAGADA BRANCH",
  "LEKKI 1 BRANCH",
  "AJOSE ADEOGUN BRANCH",
  "JIBOWU BRANCH",
  "NAHCO BRANCH",
  "OPEBI BRANCH",
  "KETU BRANCH",
  "ORILE COKER",
  "ABULE-EGBA BRANCH",
  "SATELLITE TOWN BRANCH",
  "IKEJA, AWOLOWO WAY",
  "OJOTA BRANCH",
  "NNAMDI AZIKWE STREET IDUMOTA",
  "EGBEDA BRANCH",
  "ODOGUNYAN BRANCH",
  "IKOTUN BRANCH",
  "SOMOLU BRANCH",
  "AYOBO BRANCH",
  "EJIGBO BRANCH",
  "LASU BRANCH",
  "BODE THOMAS BRANCH",
  "IJESHATEDO BRANCH",
  "MUSHIN BRANCH",
  "UNIVERSITY OF LAGOS BRANCH",
  "IRE AKARI BRANCH",
  "SABO YABA BRANCH",
  "MURI OKUNOLA BRANCH",
  "SAKA TINUBU BRANCH",
  "LAWANSON BRANCH",
  "IJU BRANCH",
  "OSHODI BRANCH",
  "IDIMU BRANCH",
  "ADENIJI ADELE BRANCH",
  "DOPEMU BRANCH",
  "FESTAC 2 BRANCH",
  "EPE BRANCH",
  "ADMIRALTY WAY BRANCH",
  "IBEJU LEKKI",
  "EBUTE METTA BRANCH",
  "LASU CAMPUS BRANCH",
  "ISOLO, ASA-AFARIOGUN STREET, AJAO",
  "ESTATE",
  "LAGOS ISLAND, MARINA",
  "APAPA, WHARF ROAD",
  "IKEJA, LADIPO OLUWOLE STREET",
  "LAGOS ISLAND, BALOGUN STREET",
  "ALABA INTERNATIONAL, OLD GARAGE",
  "VICTORIA ISLAND, ADEOLA ODEKU",
  "TRADE FAIR COMPLEX, ASPAMDA, HALL",
  "MATORI, LADIPO STREET",
  "COKER, LAGOS/BADAGRY EXPRESSWAY",
  "BBA LAGOS, ATIKU ABUBAKAR PLAZA",
  "EBUTE METTA, MARKET STREET",
  "OYINGBO",
  "IKOYI, AWOLOWO ROAD",
  "LAGOS ISLAND, BROAD STREET",
  "IKEJA, 60 OPEBI ROAD",
  "ALABA INTERNATIONAL, DOBBILL PLAZA",
  "AVENUE",
  "BBA LAGOS, BANK PLAZA",
  "TRADE FAIR COMPLEX, ASPAMDA",
  "OFFICE BLOCK 2",
  "OGBA, IJAIYE ROAD",
  "APAPA, OSHODI EXPRESSWAY",
  "LAGOS ISLAND, OKE ARIN",
  "YABA, HERBERT MACAULAY ROAD",
  "BRANCH",
  "IKORODU, 83 LAGOS ROAD",
  "LEKKI, LEKKI-EPE EXPRESSWAY",
  "LAGOS ISLAND, ENU OWA STREET",
  "FESTAC TOWN, SECOND AVENUE",
  "IYANA IPAJA, LAGOS ABEOKUTA",
  "EXPRESS WAY",
  "SEME BORDER, BADAGRY EXPRESS WAY",
  "LAWANSON/ITIRE RD BRANCH",
  "AMUWO ODOFIN BRANCH",
  "APAPA, LIVERPOOL ROAD",
  "ALAUSA BRANCH",
  "MAZA MAZA, OLD OJO ROAD",
  "ISOLO, MUSHIN ROAD",
  "APAPA, BURMA ROAD",
  "AJAH, LEKKI - EPE EXPRESSWAY",
  "OREGUN, ZIATECH ROAD OREGUN",
  "IDIMU, IDIMU ROAD IKOTUN",
  "ILASA, APAPA OSHODI EXPRESSWAY",
  "OKOTA, 56 AGO PALACE WAY",
  "APONGBON, ISSA WILLIAMS/OFFIN RD",
  "GBAGADA, GBAGADA EXPRESSWAY",
  "IKEJA GRA, JOEL OGUNNAIKE STREET",
  "MAGODO, CMD ROAD IKOSI",
  "AKOWONJO, SHASHA ROAD",
  "ALABA, DENSINE PLAZA OLOJO DRIVE",
  "OJUELEGBA, SHIFAWU STREET",
  "MARYLAND,MOBOLAJI BANK ANTHONY WAY",
  "BADAGRY, JOSEPH DOSU ROAD",
  "OBALENDE, KEFFI STREET",
  "SURULERE, ENITAN STREET AGUDA",
  "OSHODI, OSHODI-APAPA EXPRESSWAY",
  "AJAH, ADDO ROAD",
  "MAFOLUKU, INTL AIRPORT ROAD",
  "LEKKI PHASE I, ADMIRALTY WAY",
  "RET SHOP - JANKARA , LAGOS ISD(002)",
  "RET SHOP - OKOTA, ISOLO LAGOS (004)",
  "RET SHOP - RORO PORT (010)",
  "RET SHOP - ALUMINUM VILLAGE (011)",
  "RET SHOP - TEJUOSHO MKT, LAG (050)",
  "RET SHOP - IDDO, EBUTE METTA",
  "RET SHOP - OGUNLANA DRIVE (051)",
  "RET SHOP - ISHERI, BERGER",
  "RET SHOP - IFAKO AGEGE (080)",
  "RET SHOP-KIRIKIRI, APAPA LAGOS(083)",
  "RET SHOP - IFAKO GBAGADA (087)",
  "RET SHOP - BARIGA AKOKA (087)",
  "RET SHOP - KETU (088)",
  "RET SHOP - IKOTA, VGC LAGOS (095)",
  "RET SHOP - DALEKO (099)",
  "RET SHOP - MAFOLUKU (027)",
  "RET SHOP - OJUWOYE MARKET (099)",
  "RET SHOP - IYANA IPAJA (110)",
  "BOGIJE CLOSA OUTLET",
  "SANGOTEDO CLOSA OUTLET",
  "AGBOWA CLOSA OUTLET",
  "ETIEBET’S HOUSE BRANCH",
  "NUMBER ONE BRANCH",
  "ORIWU BRANCH",
  "LAFIA BRANCH",
  "MARARABA BRANCH",
  "KEFFI BRANCH",
  "LAFIA, DOMA ROAD",
  "AKWANGA, KEFFI ROAD",
  "KEFFI, ABUBAKAR BURGA STREET",
  "NEW KARU BRANCH",
  "RET SHOP-NASS. STATE UNI.KEFFI(073)",
  "MINNA BRANCH",
  "SULEJA BRANCH",
  "BIDA BRANCH",
  "MINNA 2 BRANCH",
  "MINNA, PAIKO ROAD",
  "SULEJA, IBB MARKET",
  "ABEOKUTA BRANCH",
  "AGBARA BRANCH",
  "OKE ILEWO BRANCH",
  "RCCG CAMP BRANCH",
  "OTTA BRANCH",
  "ILARO BRANCH",
  "IJEBU-ODE BRANCH",
  "COVENANT BRANCH",
  "SAGAMU BRANCH",
  "OOU BRANCH",
  "AKUTE BRANCH",
  "IBAFO BRANCH",
  "ABEOKUTA, UACN COMPLEX IBARA",
  "OTTA, OTTA INDUSTRIAL LAYOUT",
  "OWODE YEWA MARKET BRANCH",
  "IDI IROKO BORDER BRANCH",
  "SAGAMU, AKARIGBO STREET",
  "IJEBU ODE, 35 IBADAN ROAD",
  "OTTA, IDIROKO ROAD",
  "ABEOKUTA, ADATAN ROAD",
  "RET SHOP - BABCOCK UNIVERSITY (137)",
  "AKURE BRANCH",
  "ADO OWO ROAD BRANCH",
  "ONDO BRANCH",
  "ADEKUNLE AJASIN UNIVERSITY CAMPUS BRANCH",
  "ADEYEMI COLLEGE OF EDUCATION",
  "AKURE, OYEMEKUN STREET",
  "ONDO, YABA ROAD",
  "ORE BRANCH",
  "OWO BRANCH",
  "OSHOGBO BRANCH",
  "ILESHA BRANCH",
  "ILE IFE BRANCH",
  "OAU ILE IFE BRANCH",
  "REDEEMER UNIVERSITY EDE BRANCH",
  "OSHOGBO, GBONGAN-IBADAN ROAD",
  "IREE BRANCH",
  "ILESHA, ITA BALOGUN STREET",
  "ILE - IFE, LAGERE ROAD",
  "IPETU IJESHA BRANCH",
  "UNIVERSITY OF IBADAN,CAMPUS BRANCH",
  "DUGBE MARKET IBADAN BRANCH",
  "IWO ROAD IBADAN BRANCH",
  "BODIJA BRANCH 1",
  "NEW COURT ROAD BRANCH",
  "OYO BRANCH",
  "BODIJA BRANCH 2",
  "OJOO BRANCH",
  "OGBOMOSO BRANCH",
  "IWO ROAD 2 BRANCH",
  "EKOTEDO BRANCH IBADAN",
  "RING ROAD, IBADAN BRANCH",
  "UCH IBADAN BRANCH",
  "CHALLENGE BRANCH",
  "LAUTECH BRANCH",
  "IBADAN, LEBANON STREET",
  "APATA-IBADAN BRANCH",
  "SAKI BRANCH",
  "APOMU BRANCH",
  "ERUWA BRANCH",
  "AKANRAN - IBADAN BRANCH",
  "IBADAN, OKE - ADO",
  "IBADAN, AGODI UCH SECOND GATE",
  "IBADAN, AGBENI MARKET",
  "OGBOMOSHO, ILORIN ROAD",
  "SANGO-IBADAN BRANCH",
  "MONOTAN-IBADAN BRANCH",
  "GBAGI MARKET BRANCH",
  "JOS BRANCH",
  "JOS 1 BRANCH",
  "BUKURU BRANCH",
  "JOS, COMMERCIAL AREA",
  "JOS, AHMADU BELLO WAY",
  "JOS, CLUB ROAD",
  "BUKURU, OLD JOS ROAD",
  "RET SHOP - KATAKO (015)",
  "RET SHOP - UNIVERSITY OF JOS (055)",
  "REGIONAL OFFICE PORT HARCOURT",
  "TRANS AMADI BRANCH",
  "OLU OBASANJO BRANCH",
  "BONNY CASH CENTRE",
  "AGIP ROAD BRANCH",
  "BANK ROAD PH BRANCH",
  "RUMUOKORO BRANCH",
  "OBIGBO BRANCH",
  "WOJI BRANCH",
  "ELEME BRANCH",
  "PLOT105 OLU OBASANJO PH BRANCH",
  "EASTERN BULKCEMENT BRANCH",
  "RUMUKURISHI BRANCH",
  "UNIPORT BRANCH",
  "AZIKIWE ROAD PHC BRANCH",
  "IKOKWU BRANCH",
  "RSUST BRANCH",
  "PH, TRANS AMADI",
  "PH, 222 IKWERRE ROAD",
  "PH, FOT ONNE",
  "PH, 50 IKWERRE ROAD",
  "PORT HARCOURT 82/88 ABA RD",
  "OBIGBO PH, LOCATION ROAD",
  "PH, SILVER VALLEY TRANS-AMADI RD",
  "PH, RUMUOKORO EAST - WEST ROAD",
  "PH, OLU OBASANJO WAY",
  "RET SHOP - 316 ABA ROAD (003)",
  "RET SHOP - ODUA ROAD, PHC (003)",
  "RET SHOP - OLD ABA ROAD, PH (086)",
  "BORI BRANCH",
  "ABULOMA CLOSA OUTLET",
  "ISIOKPO BRANCH",
  "SOKOTO BRANCH",
  "SOKOTO 2 BRANCH",
  "USMAN DANFODIO UNIVERSITY BRANCH",
  "SHAGARI BRANCH",
  "SOKOTO, MAIDUGURI ROAD",
  "GADA MARKET BRANCH",
  "JALINGO, HAMMAN RUN WAY",
  "DAMATURU BRANCH",
  "POTISKUM BRANCH",
  "GUSAU BRANCH",
  "TALATA MAFARA",
  "GUSAU, CANTEEN ROAD",
  "KAURA NAMODA BRANCH"
]